/**
 * SkillDelivery Platform
 *
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 */

import React from 'react';

// 8 lifecycle states per migration 001 (persona-agent-service).
// V2 may emit lowercase, uppercase, or with separators — normalize.
const STATE_STYLES = {
  draft:            { bg: '#f1f5f9', fg: '#475569', label: 'Draft' },
  profile_building: { bg: '#cffafe', fg: '#0e7490', label: 'Profile Building' },
  profile_review:   { bg: '#fef9c3', fg: '#a16207', label: 'Profile Review' },
  test_instance:    { bg: '#ffedd5', fg: '#c2410c', label: 'Test Instance' },
  approved:         { bg: '#ccfbf1', fg: '#0f766e', label: 'Approved' },
  live:             { bg: '#dcfce7', fg: '#15803d', label: 'Live' },
  paused:           { bg: '#fef3c7', fg: '#b45309', label: 'Paused' },
  archived:         { bg: '#e2e8f0', fg: '#475569', label: 'Archived' },
};

function normalize(state) {
  if (!state) return '';
  return String(state).toLowerCase().replace(/[-\s]+/g, '_');
}

export default function LifecycleStateBadge({ state }) {
  const key = normalize(state);
  const style = STATE_STYLES[key] || { bg: '#f1f5f9', fg: '#64748b', label: state || '—' };

  return (
    <span style={{
      display: 'inline-block',
      fontSize: '11px',
      fontWeight: 600,
      padding: '2px 8px',
      borderRadius: '12px',
      background: style.bg,
      color: style.fg,
      lineHeight: 1.4,
    }}>
      {style.label}
    </span>
  );
}
